export function attachCloudFileRemove($context) {
    if (!$context.length) {
        return;
    }

    $context.on('click', ".cloud-component-remove", function (event) {
        event.preventDefault();

        const data = $(this).data();
        const componentId = data.cloudComponentId;
        const cloudInputFileNameId = data.cloudInputFileNameId;

        $context.find("#"+data.cloudDivId).find('.cloud-component-image').remove();
        $context.find("#"+data.cloudInputId).val(null);
        $context.find("." + cloudInputFileNameId).find('input').val(null);

        $context.find(".cloud-component-popup."+componentId).removeClass('hide');
        $context.find(".cloud-component-upload."+componentId).removeClass('hide uploaded');
        $context.find(".cloud-component-remove."+componentId).addClass('hide');
        $context.find(".cloud-component-change-video-image."+componentId).addClass('hide');
    });
}
